<template>
    <div>
        <div v-if="item" class="card mb-1">
            <div class="card-header p-2">
                応募状況
                <span v-if="item.proc_flg == '0'" class="text-success">進行中</span>
                <span v-else class="text-muted">完了</span>
                <span class="btn btn-link py-0" @click="openSet">設定</span>
                <div class="let-space-1">
                    <span>
                        pj.{{this.getApplyStatusDetail.proj.proj_user_group}}/
                        {{this.getApplyStatusDetail.proj.rec_user_group}}
                        <i v-if="pjDisable" class="fas fa-exclamation text-danger-cust"></i>
                    </span>
                    <span class="text-nowrap">
                        <span v-if="item.apply_mode == '0'">←</span>
                        <span v-else>→</span>
                        te.{{this.getApplyStatusDetail.tech.input_group}}/
                        {{this.getApplyStatusDetail.tech.user_group}}
                        <i v-if="teDisable" class="fas fa-exclamation text-danger-cust"></i>
                    </span>
                </div>
            </div>
            <div class="card-body p-0">
                <small>
                    <div class="container">
                        <div class="row text-center">
                            <div class="col-4 p-1">
                                <div class="border p-1">
                                    <i v-if="item.pj_see == '1'" class="far fa-eye"></i>
                                    <i v-else class="far fa-eye-slash"></i>
                                    <b>案件</b>
                                    <i v-if="item.pj_msg == '1'" class="fas fa-circle text-danger"></i>
                                </div>
                            </div>
                            <div class="col-4 py-1 px-0"><div class="border p-1"><b>管理</b></div></div>
                            <div class="col-4 p-1">
                                <div class="border p-1">
                                    <i v-if="item.te_see == '1'" class="far fa-eye"></i>
                                    <i v-else class="far fa-eye-slash"></i>
                                    <b>要員</b>
                                    <i v-if="item.te_msg == '1'" class="fas fa-circle text-danger"></i>
                                </div>
                            </div>
                        </div>
                        <div class="row text-center">
                            <div class="col-4 py-0 px-1">
                                <div class="border p-1 h-100">
                                    <span v-if="item.pj_ap_flg">{{item.pj_ap_flg}}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                            <div class="col-4 py-0 px-0">
                                <div class="border p-1 h-100">
                                    <span>{{converVal('sys_ap_flg', item.sys_ap_flg)}}</span>
                                </div>
                            </div>
                            <div class="col-4 py-0 px-1">
                                <div class="border p-1 h-100">
                                    <span v-if="item.te_ap_flg">{{item.te_ap_flg}}</span>
                                    <span v-else>-</span>
                                </div>
                            </div>
                        </div>
                        <template v-if="item.intv_type">
                            <div class="row text-center">
                                <div class="col-12 pt-1 pb-0 px-1">
                                    <div class="border p-1 h-100">
                                        <span v-if="item.intv_type == '0'">現地面談</span>
                                        <span v-else-if="item.intv_type == '1'">Web面談</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row text-center">
                                <div class="col-6 py-1 px-1">
                                    <div class="border p-1 h-100">
                                        <span v-if="item.pj_intv_d">
                                            {{item.pj_intv_d | dformats}}{{item.pj_intv_h}}:{{item.pj_intv_m}} 
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                                <div class="col-6 py-1 px-1">
                                    <div class="border p-1 h-100">
                                        <span v-if="item.te_intv_d">
                                            {{item.te_intv_d | dformats}}{{item.te_intv_h}}:{{item.te_intv_m}} 
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row text-center">
                                <div class="col-12 py-1 px-1">
                                    <div class="border p-1 h-100">
                                        <span>面談予定なし</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-if="item.is_cancel" class="row text-center">
                            <div class="col-12 pt-0 pb-1 px-1">
                                <div class="border p-1 h-100">
                                    <span v-if="item.is_cancel == '1'">正常取消</span>
                                    <span v-if="item.is_cancel == '2'">要員異常取消</span>
                                    <span v-if="item.is_cancel == '3'">案件異常取消</span>
                                    <div>{{item.cancel_reason}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </small>
            </div>
        </div>
        <!-- 設定画面 -->
        <app-set ref="appSet" :pj-disable="pjDisable" :te-disable="teDisable"></app-set>
    </div>
</template>

<script>
    import {getList, converVal} from 'pages/commons/form/selectList'
    import AppSet from './Set'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            item: Object,
            pjDisable: {
                type: Boolean,
                default: false
            },
            teDisable: {
                type: Boolean,
                default: false
            }
        },
        components: {
            AppSet
        },
        computed: {
            ...mapGetters(['getApplyStatusDetail'])
        },
        methods: {
            openSet () {
                this.$refs.appSet.openThis(this.item)
            },
            converVal (name, val) {
                return converVal(name,val)
            },
            getList (name) {
                return getList(name)
            },
        }
    }
</script>

<style lang="stylus" scoped>

</style>
